import { render, staticRenderFns } from "./Course-list.vue?vue&type=template&id=6a8eb40e&scoped=true"
import script from "./Course-list.vue?vue&type=script&lang=js"
export * from "./Course-list.vue?vue&type=script&lang=js"
import style0 from "./Course-list.vue?vue&type=style&index=0&id=6a8eb40e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8eb40e",
  null
  
)

export default component.exports